<template>
    <form class="show-more-form generator-form" @click="enableEdit">
      <div class="generator-cont margin big">
        <label class="input-cont input-cont_small"
               :class="{'error': $v.userName.$error, 'disabled-label': !faceless}">
          <p class="label">
            {{$t('forms.nameLb')}}
          </p>
          <input type="text"
                 @blur="$v.userName.$touch()"
                 @focus="$v.userName.$reset()"
                 :disabled="disabled || !faceless"
                 v-model="userName"
                 :placeholder="$t('forms.namePl')">
          <errors v-show="$v.userName.$error"></errors>
        </label>
      </div>
      <div class="generator-cont margin big" v-if="!faceless">
        <label class="input-cont input-cont_small"
               :class="{'error': $v.userSurname.$error, 'disabled-label': !faceless}">
          <p class="label">
            {{$t('forms.surnameLb')}}
          </p>
          <input type="text"
                 :disabled="disabled || !faceless"
                 @blur="$v.userSurname.$touch()"
                 @focus="$v.userSurname.$reset()"
                 v-model="userSurname"
                 :placeholder="$t('forms.surnamePl')">
          <errors v-show="$v.userSurname.$error"></errors>
        </label>
      </div>

      <div class="generator-cont margin big avatar-cont" v-if="faceless">
        <label class="input-cont input-cont_small">
          <p class="label">
            {{$t('forms.userPhoto')}}
          </p>
          <input type="file"
                 @change="addAvatar"
                 accept="image/gif, image/jpeg, image/png">
          <div class="group-avatar-cont">
            <div class="img-wrap">
              <img-dummy v-if="!userAvatar && !uploadedAvatar"></img-dummy>
              <img v-if="uploadedAvatar"
                   :src="uploadedAvatar" alt="">
              <img v-else-if="userAvatar"
                   :src="userAvatar" alt="">
              <button type="button" class="edit-btn">
                <avatar-icon :fill="'#fff'"></avatar-icon>
              </button>
            </div>
            <div class="text-wrap">
              <clip-icon class="clip-icon"></clip-icon>
              <div>
                <p class="name" v-if="fileName">
                  {{fileName | trimName}}
                </p>
                <p class="name" v-else>
                  {{$t('forms.uploadPhotoLabel')}}
                </p>
                <errors class="size"
                        :style="{color: error ? '#ED1C24' : '#505D6F', opacity: error ? 1 : .4}"
                        :type="'fileSize'"
                        min-length="1"></errors>
              </div>
            </div>

          </div>
        </label>
        <button type="button" @click="delAvatar" class="del-avatar">
          <del-icon :fill="'rgba(0, 82, 127, .4)'"></del-icon>
        </button>
      </div>

      <div class="generator-cont margin big">
        <label class="textarea-wrap margin">
          <p class="label">{{$t('forms.descLb')}}</p>
          <textarea :disabled="disabled"
                    v-model="userDesc"
                    :placeholder="$t('forms.descLb')"></textarea>
        </label>
      </div>
      <div class="generator-cont margin big">
        <p class="label">
          {{$t('forms.emailLb')}}
        </p>
        <label class="input-cont input-cont_small"
               :class="{'error': $v.userMail.$anyError, 'disabled-label': !faceless}">
          <input type="email"
                 :disabled="disabled || !faceless"
                 v-model.trim="userMail"
                 @blur="$v.userMail.$touch()"
                 @focus="$v.userMail.$reset()"
                 :placeholder="$t('forms.email')">
        </label>
        <errors :type="'mail'" v-show="$v.userMail.$anyError"></errors>
      </div>

      <div class="generator-cont margin big">
        <p class="label">
          {{$t('forms.telLb')}}
        </p>
        <label class="input-cont input-cont_small ">
          <div class="phone-cont">
            <phone-codes v-if="!disabled" :active-default="userPhone"></phone-codes>
            <input type="tel"
                   :disabled="disabled"
                   v-if="disabled"
                   v-model="userPhone"
                   :placeholder="$t('forms.telPl')">
            <input v-else
                   type="tel"
                   :disabled="disabled"
                   v-mask="activeCode.code + ' ' + activeCode.mask"
                   v-model="userPhone"
                   :class="{'phone-input': !disabled}"
            >
          </div>
        </label>
      </div>

      <h3 class="subtitle" v-if="faceless">{{$t('btns.changePass')}}</h3>
      <div class="generator-cont margin big" v-if="faceless">
        <p class="label">
          {{$t('forms.newPasswordLabel')}}
        </p>
        <label class="input-cont input-cont_small" :class="{'error': $v.newPass.$error}">
          <input type="password"
                 :disabled="disabled"
                 @focus="$v.newPass.$reset()"
                 @blur="$v.newPass.$touch();checkErrors()"
                 v-model="newPass">
        </label>
        <errors type="passLength" minLength="5" v-show="$v.newPass.$error"></errors>
      </div>
      <div class="generator-cont margin big" v-if="faceless">
        <p class="label">
          {{$t('forms.repeatPasswordPl')}}
        </p>
        <label class="input-cont input-cont_small"
               :class="{'error': $v.newPassRepeat.$error}">
          <input type="password"
                 :disabled="disabled"
                 @focus="$v.newPassRepeat.$reset()"
                 @blur="$v.newPassRepeat.$touch();checkErrors()"
                 v-model="newPassRepeat">
        </label>
        <errors type="passDouble" v-show="$v.newPassRepeat.$error"></errors>
      </div>


      <form-generator v-for="(item,i) in components"
                      :type="item.type"
                      :index="i"
                      :value="item.value"
                      :required="item.required"
                      :placeholder="item.placeholder"
                      :label="item.label"
                      :options="item.options"
                      :disabled="disabled"
                      :size="item.size"
                      v-model="item.value"
                      :validations="item.validations"
                      :mask="item.mask"
                      :multiple="item.multiple"
                      @change="changeFormItem($event, i)"
                      @del="delOption($event, i)"
                      :key="i"></form-generator>
    </form>
</template>

<script>
  import {mapState,mapMutations,mapActions, mapGetters} from 'vuex'
  import {required, email, sameAs, minLength} from 'vuelidate/lib/validators'
  import {showMoreMoreUsers} from "../../../../mixins/users/showMoreMore";
  import imgDummy from '../../../Svg/imgDummy'
  import avatarIcon from '../../../Svg/editIcon'
  import clipIcon from '../../../Svg/clipIcon'
  import delIcon from '../../../Svg/cart_control/delIcon'
  import errors from '../../../Forms/errors'
  import {tokenAndRoute} from "../../../../mixins/utils/tokenAndRoute";
  import {phoneCode} from "../../../../mixins/utils/phoneCode";

  export default {
    name: 'showMoreMore',
    mixins: [showMoreMoreUsers, tokenAndRoute, phoneCode],
    components: {
      imgDummy,
      avatarIcon,
      clipIcon,
      delIcon,
      errors,
    },
    data() {
      return {
        uploadedAvatar: '',
        error: false,
        fileName: '',
        oldError: false,
        oldPass: '',
        newPass: '',
        newPassRepeat: ''
      }
    },
    computed: {
      userAvatar: {
        get() {
          return this.editUser.avatar_url
        },
        set(val) {
          this.changeAvatarUser(val)
        }
      },
      userName: {
        get() {
          return this.editUser.first_name
        },
        set(val) {
          this.changeUserName(val)
        }
      },
      userSurname: {
        get() {
          return this.editUser.second_name
        },
        set(val) {
          this.changeUserSurname(val)
        }
      },
      faceless: {
        get() {
          return this.editUser.faceless
        }
      },
      userMail: {
        get() {
          return this.editUser.email
        },
        set(val) {
          this.changeUserMail(val)
        }
      },
      userPhone: {
        get() {
          return this.editUser.phone
        },
        set(val) {
          this.changeUserTel(val)
        }
      },
      userDesc: {
        get() {
          return this.editUser.description
        },
        set(val) {
          this.changeUserDescription(val)
        }
      }
    },
    validations: {
      userName: {
        required
      },
      userSurname: {
        required
      },
      userMail: {
        required,
        email
      },
      newPass: {
        minLength: minLength(5)
      },
      newPassRepeat: {
        required,
        sameAs: sameAs('newPass')
      }
    },
    filters: {
      trimName(val) {
        if (val.length > 25) {
          return val.slice(0, 25) + '...'
        } else {
          return val
        }
      }
    },
    methods: {
      ...mapMutations({
        updateComponentInput: 'users/UPDATE_COMPONENT_INPUT',
        changeUserName: 'users/UPDATE_USER_NAME',
        changeUserSurname: 'users/UPDATE_USER_SURNAME',
        changeUserMail: 'users/UPDATE_USER_MAIL',
        changeUserTel: 'users/UPDATE_USER_TEL',
        changeUserDescription: 'users/UPDATE_USER_DESCRIPTION',
        changeAvatarUser: 'users/UPDATE_USER_AVATAR'
      }),
      ...mapActions({
        loadAvatarInServer: 'users/updateUser',
        delAvatarUser: 'users/delAvatarUser'
      }),
      addAvatar(e) {
        const filesList = e.target.files;
        const thisFile = filesList[filesList.length - 1];
        const imgSize = thisFile.size;
        const maxSizeMB = 1048576;

        if (imgSize < maxSizeMB) {
          if (!!thisFile) {
            this.fileName = thisFile.name;
            let cntx = this;
            let token = this.token;
            let id = this.editUser.user_id || this.editUser.id;

            const reader = new FileReader();
            reader.onload = function (event) {
              const contents = event.target.result;
              cntx.loadAvatarInServer({
                token,
                id,
                avatar: thisFile
              }).then(() => {
                cntx.uploadedAvatar = contents;
                cntx.changeAvatarUser(contents)
              })
            };

            reader.readAsDataURL(thisFile);
          } else {
            this.error = true;
            setTimeout(() => {
              this.error = false
            }, 3000)
          }
        }
      },
      delAvatar() {
        this.delAvatarUser({
          token: this.token,
          id: this.editUser.user_id || this.editUser.id
        }).then(() => {
          this.uploadedAvatar = '';
          this.changeAvatarUser('')
        });
      },
      checkErrors() {
        if (this.$v.$anyError) {
          this.$emit('error')
        } else {
          this.$emit('good', {
            oldPass: this.oldPass,
            newPass: this.newPass
          })

        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .big {
    width: 100%;
  }

  .small {
    width: calc(50% - 10px);

  }

  .generator-cont {
    width: 100%;
  }

  .margin {
    margin-bottom: 10px;
  }

  .subtitle {
    font-family: MR, Arial, sans-serif;
    font-size: 14px;
    letter-spacing: 0.25px;
    margin-top: 3px;
    margin-bottom: 10px;
  }

  .avatar-cont {
    display: flex;
    align-items: center;

    input {
      position: absolute;
      width: 0;
      height: 0;
      z-index: -9999;
      opacity: 0;
    }

    .group-avatar-cont {
      display: flex;
      align-items: center;
    }

    .img-wrap {
      min-width: 64px;
      max-width: 64px;
      max-height: 64px;
      border-radius: 50%;
      border: 1px solid $lightBlue;
      min-height: 64px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      cursor: pointer;


      img {
        max-height: 61px;
        //width: auto;
        object-fit: cover;
        max-width: 61px;
        border-radius: 50%;
        height: 60px;
        max-height: 60px;
        max-width: 60px;
        border-radius: 50%;
      }
    }

    .edit-btn {
      position: absolute;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08);
      background: $lightBlue;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      bottom: 0;
      right: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
    }

    .clip-icon {
      margin-right: 10px;
    }

    .text-wrap {
      display: flex;
      align-items: flex-start;
    }

    .name {
      font-family: $mm;
      font-size: 14px;
      letter-spacing: 0.25px;
      color: $lightBlue;
    }

    .size {
      font-family: $mm;
      font-size: 12px;
      letter-spacing: .25px;
      color: $asphalt;
      opacity: .5;
    }

    .del-avatar {
      margin-left: auto;
    }
  }
</style>
